var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInfoDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A606A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4 15c0-5.744-4.656-10.4-10.4-10.4C9.256 4.6 4.6 9.256 4.6 15M2 15C2 7.82 7.82 2 15 2s13 5.82 13 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6 15c0 5.744 4.656 10.4 10.4 10.4 5.744 0 10.4-4.656 10.4-10.4m2.6 0c0 7.18-5.82 13-13 13S2 22.18 2 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.63 22.147h-3.25v-9.75h3.25v9.75zM13.38 9.702c0-.525.14-.93.424-1.213.283-.283.687-.425 1.213-.425.508 0 .904.142 1.188.425.283.283.424.688.424 1.213 0 .5-.141.893-.424 1.18-.284.288-.68.432-1.188.432-.526 0-.93-.144-1.213-.431-.283-.288-.425-.681-.425-1.181z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfoDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-info-default.40fd05947c71da3bf69ae217ad84b8c1.svg";